import { ref, markRaw } from 'vue';

import selgros from './selgros/init.js';

export const customizations = {
    modules: {
        selgros,
    },
    hooks: {},
    fieldTypes: [],
    init() {
        for (const [key, module] of Object.entries(this.modules)) {
            if (typeof module.init === 'function') {
                module.init(this);
            }

            if (typeof module.fieldTypes === 'object') {
                for (const [key, fieldType] of Object.entries(module.fieldTypes)) {
                    this.fieldTypes.push({
                        key: key,
                        name: fieldType.props.name,
                        component: markRaw(fieldType),
                    });
                }
            }
        }
    },
    addHook(name, callback) {
        if (typeof this.hooks[name] === 'undefined') {
            this.hooks[name] = [];
        }
        this.hooks[name].push(callback);
    },
    runHook(name, ...args) {
        if (typeof this.hooks[name] === 'undefined') {
            return;
        }
        this.hooks[name].forEach(callback => {
            callback(...args);
        });
    },
}
